export const validateEmail = (rule, value, callback) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    return callback(new Error('Please enter email address'));
  }
  if (!emailRegex.test(value)) {
    return callback(new Error('Please enter a valid email address'));
  }
  callback();
};

/**
 * 金额校验
 */
export const validateAmount = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('Please enter amount'));
  }
  if (isNaN(value)) {
    return callback(new Error('Please enter a valid number'));
  }
  // 非负数
  if (value < 0) {
    return callback(new Error('Please enter a non-negative number'));
  }

  // 最多四位有效小数
  if (value.toString().split('.')[1]?.length > 4) {
    return callback(new Error('Please enter a valid number with up to 4 decimal places'));
  }
  callback();
};
